<template>
  <div class="text-center">
    <div class="row no-gutters justify-content-between mb-1">
      <div class="col-sm-auto flex-grow-0">

      </div>
    </div>
    <div class="row  my-3">
      <div class="col-1 text-left">
        <label for="month" class="col-form-label">YEAR</label>
      </div>
      <div class="col-4">
        <select name="month" id="month" class="form-control form-control-sm" v-model="params.year" :disabled="isLoading">
          <option :value="null">--- ALL YEAR ---</option>
          <option :value="year" v-for="year in years">{{year}}</option>
        </select>
      </div>

      <div class="col-1 text-left">
        <small  class="col-form-label">Revision Number</small>
      </div>
      <div class="col-4">
        <button class="custom-button btn border btn-block text-left btn-sm"
                data-target="#risqFindingRevisionsModal"
                data-toggle="modal"
                style="padding-top: .35rem; padding-bottom: .35rem;"
                :disabled="isLoading"
        >
           <span style="font-size: 14px;">
              {{ showSelectedRsRevisions }}
           </span>
          <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
        </button>
      </div>

      <div class="col-2">
        <button id="committeeReport" @click="resetFilter" class="e-btn e-btn-blue-gray force-white-all">
          <font-awesome-icon class="mr-1" icon="filter"/>
          Reset Filter
        </button>
      </div>

    </div>

    <div class="row my-3">
      <div class="col-1 text-left">
        <label for="month" class="col-form-label">Month</label>
      </div>
      <div class="col-4">
        <select name="month" id="month" class="form-control form-control-sm" v-model="params.month" :disabled="isLoading">
          <option :value="null">--- ALL PERIOD ---</option>
          <option :value="month.id" v-for="month in months">{{month.name}}</option>
        </select>
      </div>

      <div class="col-1 text-left">
        <small  class="col-form-label">RISQ Finding Sections</small>
      </div>
      <div class="col-4">
        <button class="custom-button btn border btn-block text-left btn-sm"
                data-target="#risqFindingSectionsModal"
                data-toggle="modal"
                style="padding-top: .35rem; padding-bottom: .35rem;"
                :disabled="params.rs_code.length > 0 || isLoading"
        >
           <span style="font-size: 14px;">
              {{ showSelectedRsSections }}
           </span>
          <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
        </button>
      </div>

      <div class="col-2">
        <div class="float-right text-right ml-2 dropdown dropright" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
          <button id="committeeReport" aria-expanded="false" aria-haspopup="true" v-show="committeeReportRs.length" class="mr-2 e-btn e-btn-blue-gray force-white-all"
                  data-toggle="dropdown">
            <font-awesome-icon class="mr-1" icon="download"/>
            Download Summary Report
          </button>
          <div aria-labelledby="committeeReport" class="dropdown-menu">
            <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadReport('excel')" type="button">
              <font-awesome-icon icon="file-excel"/>
              Excel
            </button>
            <button class="dropdown-item text-secondary font-weight-bolder" @click.prevent="downloadReport('pdf')" type="button">
              <font-awesome-icon icon="file-pdf"/>
              PDF
            </button>
          </div>
        </div>
      </div>

    </div>
    <div class="row my-3">
      <div class="col-1 text-left">
        <label for="vessel" class="col-form-label">Vessel</label>
      </div>
      <div class="col-4">
        <select name="vessel" id="month" class="form-control form-control-sm" v-model="params.vessel" :disabled="isLoading">
          <option :value="null">--- ALL VESSEL ---</option>
          <option :value="vessel.id" v-for="vessel in vesselKeys">{{vessel.name | toUpper}}</option>
        </select>
      </div>

      <div class="col-1 text-left">
        <small  class="col-form-label">RISQ Findings</small>
      </div>
      <div class="col-4">
        <button class="custom-button btn border btn-block text-left btn-sm"
                data-target="#risqFindingCodesModal"
                data-toggle="modal"
                style="padding-top: .35rem; padding-bottom: .35rem;"
                :disabled="params.rs_section.length > 0 || isLoading"
        >
           <span style="font-size: 14px;">
              {{ showSelectedRsCodes }}
           </span>
          <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
        </button>
      </div>
    </div>

    <div class="row my-3">
      <div class="col-1 text-left">
        <small  class="col-form-label">Type of RISQ Findings</small>
      </div>
      <div class="col-4">
        <button class="custom-button btn border btn-block text-left btn-sm"
                data-target="#risqTypeOfFindingsModal"
                data-toggle="modal"
                style="padding-top: .35rem; padding-bottom: .35rem;"
                :disabled="isLoading"
        >
           <span style="font-size: 14px;">
              {{ showSelectedRsTypes }}
           </span>
          <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
        </button>
      </div>
    </div>


    <div class="row no-gutters align-items-center justify-content-between">
      <div class="col-sm-auto pb-2 mr-2">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item"
                :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div class="row no-gutters" style="height: 75vh; overflow-y: auto">
      <div class="col-12">
        <table class="small e-tbl">
          <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
          <tr>
            <th class="align-middle" scope="col">#</th>
            <th class="align-middle" scope="col">VESSEL</th>
            <th class="align-middle" scope="col">MANAGER</th>
            <th class="align-middle" style="min-width: 25em" scope="col">REPORT TITLE</th>
            <th class="align-middle" style="width: 5em" scope="col">STATUS</th>
            <th class="align-middle" style="width: 10em" scope="col">PORT</th>
            <th class="align-middle" style="width: 7em" scope="col">COUNTRY</th>
            <th class="align-middle" style="min-width: 9em" scope="col">INSPECTION DATE</th>
            <th class="align-middle" style="width: 12em" scope="col">RESPONSIBLE</th>
            <th class="align-middle" style="width: 12em" scope="col">PERSON IN CHARGE</th>
            <th class="align-middle" style="width: 12em" scope="col">RISQ FINDING CODE</th>
            <th class="align-middle" style="width: 12em" scope="col">RISQ FINDING TYPE</th>
            <th class="align-middle" style="width: 12em" scope="col">RISQ FINDING DESCRIPTION</th>
            <th class="align-middle" style="width: 12em" scope="col">ROOT CAUSE</th>
            <th class="align-middle" style="width: 12em" scope="col">PREVENTATIVE MEASURE</th>
            <th class="align-middle" style="width: 12em" scope="col">REVISION NUMBER</th>
            <th class="align-middle" style="width: 12em" scope="col">ACTION</th>
          </tr>
          </thead>

          <tbody>

          <tr v-if="isLoading">
            <td colspan="100%" class="text-center">
              <app-loading></app-loading>
            </td>
          </tr>

          <tr v-else-if="committeeReportRs.length === 0">
            <td colspan="100%" class="text-center font-weight-bold">
              NO FINDINGS FOUND
            </td>
          </tr>

          <template v-else>
            <template v-if="committeeReportRs">
              <template v-for="(report,index) in committeeReportRs">
                <template v-if="!!report.non_conformity">
                  <tr :key="index">
                    <td :rowspan="report.non_conformity.length + 1">{{ (params.page - 1) * params.perPage + index + 1 }}</td>
                    <td :rowspan="report.non_conformity.length + 1">{{ report.vessel_name || '' }}</td>
                    <td :rowspan="report.non_conformity.length + 1">{{ (report.management_office?.name || '').toUpperCase() }}</td>
                    <td :rowspan="report.non_conformity.length + 1">{{ report.title || '' }}</td>
                    <td :rowspan="report.non_conformity.length + 1" style="min-width: 100px; max-width: 150px; word-wrap: break-word;"
                        :style="{ backgroundColor: '#' + report.report_status_color, color: '#fff' }">
                      {{ (report.report_status_log?.report_status?.name || '').toUpperCase() }}
                    </td>
                    <td :rowspan="report.non_conformity.length + 1" style="min-width: 100px; max-width: 150px; word-wrap: break-word;">{{ report.port_name || '' }}</td>
                    <td :rowspan="report.non_conformity.length + 1">{{ report.country_name || '' }}</td>
                    <td :rowspan="report.non_conformity.length + 1">
                      {{
                        new Date(report.inspection_commencement_date).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        })
                      }}
                      <br />
                      {{
                        new Date(report.inspection_commencement_date).toLocaleTimeString('en-GB', {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true
                        })
                      }}
                    </td>
                    <td :rowspan="report.non_conformity.length + 1">{{(report.responsible_person?.first_name || '') + ' ' + (report.responsible_person?.last_name || '') }}</td>
                    <td :rowspan="report.non_conformity.length + 1" style="min-width: 100px; max-width: 150px;
                    word-wrap: break-word;">{{(report.person_in_charge?.first_name || '') + ' ' + (report.person_in_charge?.last_name || '') }}
                    </td>
                  </tr>
                  <template v-if="report.non_conformity.length">
                    <tr v-for="(nc, ncIndex) in report.non_conformity" :class="{ 'border-bottom': isLastNc(report, ncIndex) }">
                      <td>{{ nc.rsn_question?.code || '' }}</td>
                      <td style="min-width: 100px; max-width: 150px; word-wrap: break-word;">{{ nc.type_of_finding || '' }}</td>
                      <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                        <div>
                          <span>
                            {{ decodeHtml((nc.description || '').replace(/<\/?[^>]+(>|$)/g, '')).slice(0, isExpanded(nc.id,'description') ? undefined : 200) }}
                            <span v-if="(nc.description || '').length > 200 && !isExpanded(nc.id,'description')">...</span>
                            <span
                              v-if="(nc.description || '').length > 200"
                              class="text-primary"
                              style="cursor:pointer;"
                              @click="toggleExpand(nc.id,'description')"
                            >
                              {{ isExpanded(nc.id,'description') ? ' Show Less' : ' See More' }}
                            </span>
                          </span>
                        </div>
                      </td>
                      <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                        <div>
                          <span>
                            {{ decodeHtml((nc.root_cause_detail || '').replace(/<\/?[^>]+(>|$)/g, '')).slice(0, isExpanded(nc.id,'root_cause') ? undefined : 200) }}
                            <span v-if="(nc.root_cause_detail || '').length > 200 && !isExpanded(nc.id,'root_cause')">...</span>
                            <span
                              v-if="(nc.root_cause_detail || '').length > 200"
                              class="text-primary"
                              style="cursor:pointer;"
                              @click="toggleExpand(nc.id,'root_cause')"
                            >
                              {{ isExpanded(nc.id,'root_cause') ? ' Show Less' : ' See More' }}
                            </span>
                          </span>
                        </div>
                      </td>
                      <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                        <div>
                          <span>
                            {{ decodeHtml((nc.preventative_measure?.description || '').replace(/<\/?[^>]+(>|$)/g, '')).slice(0, isExpanded(nc.id,'preventative_measure') ? undefined : 200) }}
                            <span v-if="(nc.preventative_measure?.description || '').length > 200 && !isExpanded(nc.id,'preventative_measure')">...</span>
                            <span
                              v-if="(nc.preventative_measure?.description || '').length > 200"
                              class="text-primary"
                              style="cursor:pointer;"
                              @click="toggleExpand(nc.id,'preventative_measure')"
                            >
                              {{ isExpanded(nc.id,'preventative_measure') ? ' Show Less' : ' See More' }}
                            </span>
                          </span>
                        </div>
                      </td>
                      <td>{{ nc.revision_number.revision_number || '' }}</td>
                      <td>
                        <div class="dropdown dropright my-1">
                          <button id="actionDropdown" aria-expanded="false" aria-haspopup="true"
                                  class="btn btn-sm btn-secondary force-white-all" data-toggle="dropdown">
                            <font-awesome-icon icon="cogs"/>
                          </button>
                          <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                            <button class="dropdown-item text-secondary font-weight-bolder"
                                    @click="showRsInspection(report.id)">
                              <font-awesome-icon icon="eye"/>
                              View
                            </button>
                            <button class="dropdown-item text-secondary font-weight-bolder"
                                    @click="showRsInspectionOnNewTab(report.id)">
                              <font-awesome-icon icon="eye"/>
                              View on New Tab
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </template>
                <template v-else>
                  <tr :key="index">
                    <td>{{ report.vessel_name || '' }}</td>
                    <td>{{ (report.management_office?.name || '').toUpperCase() }}</td>
                    <td style="min-width: 100px; max-width: 150px; word-wrap: break-word;"
                        :style="{ backgroundColor: '#' + report.report_status_color, color: '#fff' }">
                      {{ (report.report_status_log?.report_status?.name || '').toUpperCase() }}
                    </td>
                    <td style="min-width: 100px; max-width: 150px; word-wrap: break-word;">{{ report.port_name || '' }}</td>
                    <td>{{ report.country_name || '' }}</td>
                    <td>
                      {{
                        new Date(report.inspection_commencement_date).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric'
                        })
                      }}
                      <br />
                      {{
                        new Date(report.inspection_commencement_date).toLocaleTimeString('en-GB', {
                          hour: '2-digit',
                          minute: '2-digit',
                          hour12: true
                        })
                      }}
                    </td>
                    <td>{{(report.responsible_person?.first_name || '') + ' ' + (report.responsible_person?.last_name || '') }}</td>
                    <td style="min-width: 100px; max-width: 150px;
                    word-wrap: break-word;">{{(report.person_in_charge?.first_name || '') + ' ' + (report.person_in_charge?.last_name || '') }}
                    </td>
                  </tr>
                  <tr class="border-bottom">
                    <td colspan="7">NO FINDINGS FOUND</td>
                  </tr>
                </template>
              </template>
            </template>
          </template>

          </tbody>
        </table>
      </div>
    </div>

    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="risqFindingCodesModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">SELECT RISQ FINDING</h5>
            <button type="button" class="close" @click="discardSelectedRsCodes" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto " style="height: 50vh">
            <template v-for="(node,index) in rsncQuestionKeys">
              <div class="row align-items-start d-flex pl-2 pt-2 pb-2">
                <h6 class="h6 text-uppercase" style="font-weight: bold">SECTION {{node.code}}: {{node.main_question}}</h6>
              </div>
              <template v-for="(child, index) in node.children">
                <div class="form-check form-check-inline align-items-start d-flex pb-2">
                  <input
                    type="checkbox"
                    class="form-check-input expand-25-percent mr-2 mt-1 cursor-pointer"
                    :id="'code-' + child.id"
                    :value="child.id"
                    v-model="modalRsCodes"
                  />
                  <label :for="'code-' +child.id" class="form-check-label d-inline-flex flex-wrap h6 text-left cursor-pointer"
                         :class="{ 'font-weight-bold': modalRsCodes.includes(child.id) }">
                    {{child.code}} {{ child.main_question }}
                  </label>
                </div>
              </template>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="applySelectedRsCodes">Select</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="risqFindingSectionsModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">SELECT RISQ FINDING SECTION</h5>
            <button type="button" class="close" @click="discardSelectedRsSections" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto" style="height: 50vh">
            <template v-for="(node,index) in rsncQuestionKeys">
              <div class="form-check form-check-inline align-items-start d-flex pb-2">
                <input
                  type="checkbox"
                  class="form-check-input expand-25-percent mr-2 mt-1 cursor-pointer"
                  :id="'section-' + node.id"
                  :value="node.id"
                  v-model="modalRsSections"
                />
                <label :for="'section-' + node.id" class="form-check-label d-inline-flex flex-wrap h6 text-left text-uppercase cursor-pointer"
                       :class="{ 'font-weight-bold': modalRsSections.includes(node.id) }">SECTION {{ node.code }}: {{ node.main_question }}</label>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="applySelectedRsSections">Select</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="risqTypeOfFindingsModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">SELECT TYPE OF RISQ FINDING</h5>
            <button type="button" class="close" @click="discardSelectedRsTypes" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto" style="height: 50vh">
            <template v-for="(node,index) in rsTypeOfFindings">
              <div class="form-check form-check-inline align-items-start d-flex pb-2">
                <input
                  type="checkbox"
                  class="form-check-input expand-25-percent mr-2 mt-1 cursor-pointer"
                  :id="'type-' + node.id"
                  :value="node.id"
                  v-model="modalRsTypes"
                />
                <label :for="'type-' + node.id" class="form-check-label d-inline-flex flex-wrap h6 text-left cursor-pointer text-uppercase"
                       :class="{ 'font-weight-bold': modalRsTypes.includes(node.id) }">{{ node.type }}</label>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="applySelectedRsTypes">Select</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="risqFindingRevisionsModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">SELECT REVISION NUMBER</h5>
            <button type="button" class="close" @click="discardSelectedRsRevisions" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto" style="height: 50vh">
            <template v-for="(node,index) in revisions">
              <div class="form-check form-check-inline align-items-start d-flex pb-2">
                <input
                  type="checkbox"
                  class="form-check-input expand-25-percent mr-2 mt-1 cursor-pointer"
                  :id="'revision-' + node.id"
                  :value="node.id"
                  v-model="modalRsRevisions"
                />
                <label :for="'revision-' + node.id" class="form-check-label d-inline-flex flex-wrap h6 text-left cursor-pointer"
                       :class="{ 'font-weight-bold': modalRsRevisions.includes(node.id) }">v{{ node.revision_number }}</label>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="applySelectedRsRevisions">Select</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading.vue";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import _ from "lodash";
import AttachmentMixin from "@/mixins/attachmentMixin";
import RsncQuestionComponent from "@/components/modules/rightship/RsncQuestionComponent.vue";
import {RS_REPORT_INDEX} from "@/services/ConstantService";
import {UrlService} from "@/services/UrlService";
import axios from "axios";
import {GlobalService} from "@/services/GlobalService";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: "RsSummaryOfFindings",
  components:{RsncQuestionComponent, AppLoading},
  mixins:[PaginationMixin,AttachmentMixin, permissionMixin],
  data(){
    return {
      rsTypeOfFindings: [
        { id: 1, type: 'Deficiency' },
        { id: 2, type: 'Observation' },
        { id: 3, type: 'Recommendation' }
      ],
      modalRsRevisions: [],
      modalRsTypes: [],
      modalRsSections: [],
      modalRsCodes: [],
      expandedFindings: {},
      code:{},
      isLoading:false,
      params:{
        vessel:null,
        page:1,
        perPage:10,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        rs_section: [],
        revision_number_id: [],
        rs_code: [],
        type_of_finding: [],
      },
      months:[
        {
          id:1,
          name:'JANUARY'
        },
        {
          id:2,
          name:'FEBRUARY'
        },
        {
          id:3,
          name:'MARCH'
        },
        {
          id:4,
          name:'APRIL'
        },
        {
          id:5,
          name:'MAY'
        },
        {
          id:6,
          name:'JUNE'
        },
        {
          id:7,
          name:'JULY'
        },
        {
          id:8,
          name:'AUGUST'
        },
        {
          id:9,
          name:'SEPTEMBER'
        },
        {
          id:10,
          name:'OCTOBER'
        },
        {
          id:11,
          name:'NOVEMBER'
        },
        {
          id:12,
          name:'DECEMBER'
        },
      ],
      years:Array.from({length:100},(_,i)=>new Date().getFullYear() - i)
    }
  },
  computed:{
    ...mapGetters(['committeeReportRs','vesselKeys', 'rsncQuestionKeys']),
    ...mapGetters('revision', ['revisions']),
    showSelectedRsCodes() {
      if (!this.params.rs_code || this.params.rs_code.length === 0) {
        return '--- ALL FINDINGS ---';
      }

      const allChildren = this.rsncQuestionKeys.flatMap(node => node.children);

      const selectedCodes = this.params.rs_code
        .map(id => {
          const child = allChildren.find(c => c.id === id);
          return child ? child.code : null;
        })
        .filter(Boolean);

      return selectedCodes.join(', ');
    },
    showSelectedRsSections() {
      if (!this.params.rs_section || this.params.rs_section.length === 0) {
        return '--- ALL FINDING SECTIONS ---';
      }

      const selectedSections = this.params.rs_section
        .map(id => {
          const parent = this.rsncQuestionKeys.find(node => node.id === id);
          return parent ? `SECTION ${parent.code}` : null;
        })
        .filter(Boolean);

      return selectedSections.join(', ');
    },
    showSelectedRsTypes() {
      if (!this.params.type_of_finding || this.params.type_of_finding.length === 0) {
        return '--- ALL TYPES OF FINDING ---';
      }
      const selected = this.rsTypeOfFindings
        .filter(t => this.params.type_of_finding.includes(t.id))
        .map(t => t.type);

      return selected.join(', ');
    },

    showSelectedRsRevisions() {
      if (!this.params.revision_number_id || this.params.revision_number_id.length === 0) {
        return '--- ALL REVISION NUMBERS ---';
      }

      const selectedRevisions = this.revisions
        .filter(r => this.params.revision_number_id.includes(r.id))
        .map(r => r.revision_number);

      return selectedRevisions.join(', ');
    },
  },
  methods:{
    ...mapActions(['getCommitteeReportsRs','getVesselKeys', 'getRsncQuestionKeys']),
    ...mapActions('revision', ['fetchRevisions']),
    applySelectedRsRevisions() {
      this.params.revision_number_id = [...this.modalRsRevisions];
      this.params.page = 1;
    },
    discardSelectedRsRevisions() {
      this.modalRsRevisions = [...this.params.revision_number_id];
    },
    applySelectedRsTypes() {
      this.params.type_of_finding = [...this.modalRsTypes];
      this.params.page = 1;
    },
    discardSelectedRsTypes() {
      this.modalRsTypes = [...this.params.type_of_finding];
    },
    applySelectedRsSections() {
      this.params.rs_section = [...this.modalRsSections];
      this.params.page = 1;
    },
    discardSelectedRsSections() {
      this.modalRsSections = [...this.params.rs_section];
    },
    applySelectedRsCodes() {
      this.params.rs_code = [...this.modalRsCodes];
      this.params.page = 1;
    },
    discardSelectedRsCodes() {
      this.modalRsCodes = [...this.params.rs_code];
    },
    isLastNc(report, ncIndex) {
      return ncIndex === report.non_conformity.length - 1;
    },
    toggleExpand(ncId, field) {
      if (!this.expandedFindings[ncId]) {
        this.$set(this.expandedFindings, ncId, {
          description: false,
          root_cause: false,
          preventative_measure: false
        });
      }
      this.expandedFindings[ncId][field] = !this.expandedFindings[ncId][field];
    },
    isExpanded(ncId, field) {
      return this.expandedFindings[ncId]?.[field] || false;
    },
    showRsInspection(inspectionId) {
      this.$router.push(
        {
          name: 'RsMain',
          params: {
            id: inspectionId
          }
        }
      );
    },
    showRsInspectionOnNewTab(inspectionId) {
      const route= this.$router.resolve(
        {
          name: 'RsMain',
          params: {
            id: inspectionId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    sortRsncKeys() {
      const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
      this.rsncQuestionKeys.sort((a, b) => collator.compare(a.code, b.code));
    },
    async setPage(page = null){
      delete this.params.type
      this.isLoading=true;
      this.params.page = page ?? 1;
      try {
        await this.getCommitteeReportsRs(this.params);
      } catch (e) {
        console.error('Error fetching committee reports:', e);
      } finally {
        this.isLoading = false;
      }
      this.isLoading=false;
    },
    async resetFilter() {
      this.params=Object.assign({},{
        vessel:null,
        page:1,
        perPage:10,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        revision_number_id: [],
        rs_code: [],
        rs_section: [],
        type_of_finding: []
      })
      this.modalRsCodes = [];
      this.modalRsSections = [];
      this.modalRsTypes = [];
      this.modalRsRevisions = [];
      this.code={};
      await this.getCommitteeReportsRs(this.params);
    },
    async downloadReport(fileType){
      const params=this.params
      params[fileType]=1;
      fileType === 'excel' ? delete params.pdf : delete params.excel;

      const uri = [RS_REPORT_INDEX, 'committee'].join('/')
      const queryString= UrlService.setQueryString(params)
      swal.fire({
        'title': `GENERATING FINDINGS SUMMARY REPORT <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      await axios({
        url:uri + queryString,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          swal.close()
          let mime_type = fileType==='pdf' ? 'application/pdf' : 'application/vnd.ms-excel'
          let url = window.URL.createObjectURL(new Blob([response.data],{type:mime_type}))

          fileType = (fileType !== 'pdf') ? 'xlsx' : 'pdf';

          let filename=`RS_FINDINGS_SUMMARY_REPORT_${Date.now()}.${fileType}`
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }).catch(error => {
          GlobalService.handleError(error, 'DOWNLOAD RS FINDINGS SUMMARY SERVICE')
          return false
        }).finally(() => {
          delete this.params.pdf;
          delete this.params.excel;
        });
    }
  },
  created() {
    this.debouncedSetPage=_.debounce(this.setPage,750);
    this.getVesselKeys();
    this.getRsncQuestionKeys().then(() => {
      this.sortRsncKeys();
    });
    this.fetchRevisions();
    this.setPage();
  },

  watch:{
    "params.year"(){
      this.debouncedSetPage();
    },
    "params.month"(){
      this.debouncedSetPage();
    },
    "params.vessel"(){
      this.debouncedSetPage();
    },
    "params.rs_section"(){
      this.debouncedSetPage();
    },
    "params.revision_number_id"(){
      this.debouncedSetPage();
    },
    "params.type_of_finding"(){
      this.debouncedSetPage();
    },
    "params.rs_code"(){
      this.debouncedSetPage();
    },
  }
}
</script>

<style scoped>
.custom-button:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.border-bottom {
  border-bottom: 2px solid black !important;
}
</style>
